import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import ChartWrapper from 'components/Apps/EnvironmentMonitor/ChartWrapper'
import ListWrapper from 'components/Apps/EnvironmentMonitor/ListView'
import { SpeedWhite } from 'helpers/customIcons'
import {
  fetchHistoricalData,
  fetchForecastData,
} from 'reducers/environmentMonitor/reducer'
import {
  CHART_TYPE_FORECAST,
  TYPE_SPEED,
  isBoundaryLineShow,
  CHART_TYPE_HISTORICAL,
} from 'helpers/environmentMonitor'
import ChartStv from 'components/Apps/EnvironmentMonitor/Charts/ChartStv'
import ChartHistorical from 'components/Apps/EnvironmentMonitor/Charts/ChartHistorical'

class Current extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chartType: CHART_TYPE_FORECAST,
      datasetIndex: 1,
    }
  }

  componentList = {
    [`${CHART_TYPE_FORECAST}`]: ChartStv,
    [`${CHART_TYPE_HISTORICAL}`]: ChartHistorical,
  }

  componentDidMount() {
    this.fetchChartData(this.props.activeSite, this.state.chartType)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.activeSite !== nextProps.activeSite ||
      this.state.chartType !== nextState.chartType
    ) {
      this.fetchChartData(nextProps.activeSite, nextState.chartType)

      return false
    }

    return true
  }

  fetchChartData = (activeSite, chartType) => {
    const { fetchForecastData, fetchHistoricalData } = this.props
    const payload = {
      site: activeSite,
      now: moment.utc().format('YYYY-MM-DD HH:00:00'),
      type: TYPE_SPEED,
    }

    if (chartType === CHART_TYPE_FORECAST) {
      payload.depth = 5
      fetchForecastData(payload)
    } else {
      fetchHistoricalData(payload)
    }
  }

  onChartTypeBtnClick = evt => {
    this.setState({
      chartType: evt.currentTarget.value,
      datasetIndex: evt.currentTarget.value === CHART_TYPE_FORECAST ? 1 : 0,
      itemIndex: 0,
    })
  }

  render() {
    const { chartData } = this.props
    const { chartType, datasetIndex } = this.state
    const lineLevels = isBoundaryLineShow(
      chartData.get('data').toJS(),
      chartType,
      20,
      val => val > 20,
    )
    const ChartView = this.componentList[chartType]

    return (
      <>
        <ChartWrapper
          loader={chartData.get('loader')}
          chartType={chartType}
          chartTypeChange={this.onChartTypeBtnClick}>
          <ChartView
            unit="cm/s"
            chartData={chartData}
            datasetIndex={datasetIndex}
            lineLevels={lineLevels}
          />
        </ChartWrapper>
        <ListWrapper
          unit="cm/s"
          icon={SpeedWhite}
          dataView={chartData.get('dataView')}
          chartType={chartType}
        />
      </>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    chartData: state.getIn(['environmentMonitor', 'chartData']),
  }),
  {
    fetchHistoricalData,
    fetchForecastData,
  },
)(Current)
